module.exports = __WEBPACK_EXTERNAL_MODULE_217__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 217
// module chunks = 0